import React from 'react'
import type { HistoricalReport } from '../../../shared/domain/viewableReports/types.no-deps'

interface ExpandedContentProps {
    renderReport: (report: HistoricalReport) => React.ReactNode
    reports: HistoricalReport[]
}

export function OriginatingReports(props: ExpandedContentProps) {
    return (
        <ul className="AppCore__OriginatingReport__Tiles">
            {props.reports.map((report) => (
                <li key={report.reportViewData.reportId}>{props.renderReport(report)}</li>
            ))}
        </ul>
    )
}
